import { render, staticRenderFns } from "./per-product.vue?vue&type=template&id=74ce534c&scoped=true&"
import script from "./per-product.vue?vue&type=script&lang=js&"
export * from "./per-product.vue?vue&type=script&lang=js&"
import style0 from "./per-product.vue?vue&type=style&index=0&id=74ce534c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ce534c",
  null
  
)

export default component.exports